import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import pagesRoutes from "routes/basicPages.jsx";

import pagesStyle from "assets/jss/material-dashboard-pro-react/layouts/pagesStyle.jsx";

import bgImage from "assets/img/web-background2.jpg";

import NotificationWrapper from "./hoc/NotificationWrapper";

class BasicPages extends React.Component {
  render() {
    return (
      <NotificationWrapper>
        <div
          style={{
            backgroundImage: "url(" + bgImage + ")",
            backgroundSize: "cover",
            height: "100vh",
            width: "100vw"
          }}
        >
          <Switch>
            {pagesRoutes.map((prop, key) => {
              if (prop.collapse) {
                return null;
              }
              if (prop.redirect) {
                return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
              }
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            })}
          </Switch>
        </div>
      </NotificationWrapper>
    );
  }
}

BasicPages.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(pagesStyle)(BasicPages);



// WEBPACK FOOTER //
// ./src/layouts/BasicPages.jsx